module.exports = __webpack_public_path__ + "static/weronikawork8-a2766a999308ae7050035cc53084d583.jpg";